import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/List';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: any): any {
    return this.http.post(`${environment.apiUrl}/Lookup/GetAllCategory`, filter);
  }
  GetDetails(id: string) {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCategoryId?id=${id}`);
  }
  delete(id: string) {
    return this.http.post(`${environment.apiUrl}/Lookup/DeleteCategory?id=${id}`, null);
  }
  saveRecord(data: any) {
    if (data.id) {
      return this.http.post(`${environment.apiUrl}/Lookup/EditCategory`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/Lookup/NewCategory`, data);
    }
  }
  getAllCategory(restaurantId: number): any {
    return this.http.get(`${environment.apiUrl}/Lookup/GetCategory?RestaurantId=${restaurantId}`);
  }
}
